export default "__VITE_ASSET__DkDolClu__"